import service from "@/services/types/situacionComprobante";

export const namespaced = true;

export const state = () => ({
  list: [],
});

export const mutations = {
  LIST: (state, objs) => (state.list = objs),
};

export const actions = {
  list: ({ commit, state }, value) =>
    state.list?.length
      ? state.list
      : service.list(value).then((result) => commit("LIST", result) || result),
};

export const getters = {
  get: (state) => (_id) => state.list.find(({ id }) => id === _id),
};
